import format from "date-fns/format";

export function currentMonth() {
  return new Date().getMonth() + 1;
}

export function currentYear() {
  return new Date().getFullYear();
}

export const months = [
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 }
];

export function years() {
  let data = [];
  const currentYear = new Date().getFullYear();

  for (let index = currentYear; index >= 2000; index--) {
    data.push({
      label: index,
      value: index
    });
  }

  return data;
}

export function dateTime(date = new Date(), dateFormat = "yyyy-MM-dd HH:mm:ss") {
  if (!date) return "";

  const formattedDate = format(new Date(date), dateFormat);

  return formattedDate;
}

// delivery date time format
export function deliveryDate(date = new Date()) {
  if (!date) return "";
  return dateTime(date, "MMMM d, yyyy h:mm aa");
}

// print date format
export function printDate(date = new Date()) {
  if (!date) return "";

  return dateTime(date, "MMMM dd, yyyy");
}

export function tableDate(date) {
  if (!date) return "-";
  return (
    <>
      <div>{dateTime(new Date(date), "d MMM yyyy")}</div>
      <div>{dateTime(new Date(date), "EE hh:mmaaa")}</div>
    </>
  );
}
